module.exports = __webpack_public_path__ + "static/media/bg32a-filled.cee0e48a.png";